// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { NotFoundErrorBoundary } from '@/components/not-found-error-boundary';
import { MembershipReportTab } from '@/membership/components/members-tab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/projects/$projectKey/members')({
  component: ProjectMembersRoute,
});

/** Route component for a project's members. */
function ProjectMembersRoute() {
  const { projectKey } = Route.useParams();

  return (
    <NotFoundErrorBoundary
      entityType="project"
      listPath="/projects"
      listLabel="Go to projects"
    >
      <MembershipReportTab projectKey={projectKey} />
    </NotFoundErrorBoundary>
  );
}
